export default __webpack_public_path__ + "static/media/producto_destacado.b2cb6df7.svg";